import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'motion/react';
import { ArrowRight } from 'lucide-react';
import toast from 'react-hot-toast';
import { PageHeader, Button, subtleNeo } from '@brainsway/ui';
import { HospitalForm } from '../components/HospitalForm';
import { useCreateHospital } from '../hooks';
import type { HospitalFormData } from '../types';

export function CreateHospitalPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const createMutation = useCreateHospital();

  const handleSubmit = (data: HospitalFormData) => {
    createMutation.mutate(data, {
      onSuccess: () => {
        toast.success(t('hospitals.created', 'Hospital created'));
        navigate('/admin/hospitals');
      },
      onError: (err: any) => {
        const message = err.response?.data?.message || t('common.error');
        toast.error(message);
      },
    });
  };

  return (
    <motion.div initial="hidden" animate="visible" variants={subtleNeo.fadeIn} className="mx-auto max-w-2xl space-y-5">
      <PageHeader
        title={t('hospitals.createHospital', 'Add Hospital')}
        backButton={
          <Link to="/admin/hospitals">
            <Button variant="ghost" size="icon"><ArrowRight className="h-5 w-5 rtl:rotate-180" /></Button>
          </Link>
        }
      />
      <HospitalForm
        onSubmit={handleSubmit}
        isLoading={createMutation.isPending}
      />
    </motion.div>
  );
}
